export const FILES = ['a','b','c','d','e','f','g','h'] as const;
export const RANKS = ['8','7','6','5','4','3','2','1'] as const;

export type PieceCode =
  | 'wK' | 'wQ' | 'wR' | 'wB' | 'wN' | 'wP'
  | 'bK' | 'bQ' | 'bR' | 'bB' | 'bN' | 'bP';

export type BoardMap = Record<string, PieceCode>;

export const GLYPH: Record<PieceCode, string> = {
  wK: '♔', wQ: '♕', wR: '♖', wB: '♗', wN: '♘', wP: '♙',
  bK: '♚', bQ: '♛', bR: '♜', bB: '♝', bN: '♞', bP: '♟'
};

export const SPARE: PieceCode[] = ['wK','wQ','wR','wB','wN','wP','bK','bQ','bR','bB','bN','bP'];

export function startBoard(): BoardMap {
  return {
    a8:'bR', b8:'bN', c8:'bB', d8:'bQ', e8:'bK', f8:'bB', g8:'bN', h8:'bR',
    a7:'bP', b7:'bP', c7:'bP', d7:'bP', e7:'bP', f7:'bP', g7:'bP', h7:'bP',
    a2:'wP', b2:'wP', c2:'wP', d2:'wP', e2:'wP', f2:'wP', g2:'wP', h2:'wP',
    a1:'wR', b1:'wN', c1:'wB', d1:'wQ', e1:'wK', f1:'wB', g1:'wN', h1:'wR'
  };
}

export function boardFromFen(fen: string): BoardMap {
  const out: BoardMap = {};
  const placement = ((fen || '').trim().split(/\s+/)[0] || '');
  const rows = placement.split('/');
  if (rows.length !== 8) return startBoard();

  for (let rankIndex = 0; rankIndex < rows.length; rankIndex += 1) {
    const row = rows[rankIndex];
    let fileIndex = 0;

    for (const char of row) {
      if (/^[1-8]$/.test(char)) {
        fileIndex += Number(char);
        continue;
      }
      if (!'KQRBNPkqrbnp'.includes(char) || fileIndex >= 8) return startBoard();

      const color = char === char.toUpperCase() ? 'w' : 'b';
      const piece = color + char.toUpperCase();
      const square = String.fromCharCode(97 + fileIndex) + String(8 - rankIndex);
      out[square] = piece as PieceCode;
      fileIndex += 1;
    }

    if (fileIndex !== 8) return startBoard();
  }

  return out;
}

export function fenFromBoard(board: BoardMap, turn: 'w' | 'b') {
  const rows: string[] = [];
  for (let rank = 8; rank >= 1; rank -= 1) {
    let empty = 0;
    let row = '';
    for (let file = 0; file < 8; file += 1) {
      const square = String.fromCharCode(97 + file) + rank;
      const piece = board[square];
      if (!piece) {
        empty += 1;
        continue;
      }
      if (empty) { row += String(empty); empty = 0; }
      row += piece[0] === 'w' ? piece[1] : piece[1].toLowerCase();
    }
    if (empty) row += String(empty);
    rows.push(row);
  }
  return rows.join('/') + ' ' + turn + ' KQkq - 0 1';
}
